"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = exports.Row = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.Row = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  height: 48px;
  background: ${({ $odd }) => ($odd ? colors_1.LIGHT_GREY : colors_1.WHITE)};
`;
exports.Label = styled_components_1.default.label `
  font-size: 16px;
  color: ${colors_1.GREY4};
`;
//# sourceMappingURL=CalculationRow.styles.js.map